
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oil-recycling/[city]",
      function () {
        return require("private-next-pages/oil-recycling/[city].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oil-recycling/[city]"])
      });
    }
  